export const student = {
    // 作业列表页面
    "student_homework_title": "My Homework",
    "student_homework_load_error": "Failed to load homework list",
    "student_homework_load_detail_error": "Failed to load homework details",
    "student_homework_no_class": "You are not enrolled in any classes",
    "student_homework_no_homework": "No homework available",
    "student_homework_no_data": "No data",

    // 筛选和搜索
    "student_homework_select_class": "Select Class",
    "student_homework_all_subjects": "All Subjects",
    "student_homework_search_placeholder": "Search homework name or description",
    "student_homework_class_ended": "Ended",

    // 表格列
    "student_homework_column_name": "Name",
    "student_homework_column_subject": "Subject",
    "student_homework_column_description": "Description",
    "student_homework_column_use_time": "Duration",
    "student_homework_column_score": "Score",
    "student_homework_column_created_at": "Created At",
    "student_homework_column_actions": "Actions",

    // 统计
    "student_homework_current_class": "Current Class",
    "student_homework_total_count": "Total Homework",
    "student_homework_available": "Available",
    "student_homework_total": "Total {{total}} items",

    // 操作按钮
    "student_homework_start": "Start",
    "student_homework_continue": "Continue",
    "student_homework_view": "View",
    "student_homework_load_more": "Load More",
    "student_homework_refresh": "Refresh",
    "student_homework_view_mode_card": "Card View",
    "student_homework_view_mode_list": "List View",

    // 时间单位
    "student_homework_minutes": "min",
    "student_homework_seconds": "s",

    // 作业详情/作答 Modal
    "student_homework_preview": "Preview",
    "student_homework_answered": "Answered",
    "student_homework_not_answered": "Not answered",
    "student_homework_your_answer": "Your Answer",
    "student_homework_simple_text_placeholder": "Enter your answer",
    "student_homework_true": "True",
    "student_homework_false": "False",

    // 作答状态
    "student_homework_progress": "Progress",
    "student_homework_use_time_limit": "Time Limit",
    "student_homework_completion_rate": "Completion Rate",
    "student_homework_finished": "Completed",
    "student_homework_wait_grade": "Waiting for Teacher Review",
    "student_homework_wait_grade_desc": "You have submitted. Please wait for the teacher to grade before viewing your score.",
    "student_homework_your_answers": "Your Answers",
    "student_homework_score_display": "Score: {{score}} / {{total}}",

    // 作业详情
    "student_homework_answer_detail": "Answer Details",
    "student_homework_start_time": "Start Time",
    "student_homework_end_time": "End Time",
    "student_homework_answer_restored": "Previous answers restored",

    // 操作按钮
    "student_homework_back": "Back",
    "student_homework_cancel": "Cancel",
    "student_homework_close": "Close",
    "student_homework_save_cache": "Save Draft",
    "student_homework_submit": "Submit",

    // 确认对话框
    "student_homework_submit_confirm_title": "Confirm Submit",
    "student_homework_submit_confirm_content": "You have answered {{answered}}/{{total}} questions. Are you sure you want to submit?",
    "student_homework_unanswered_warning": "You have unanswered questions (answered {{answered}}/{{total}}). Scrolled to the first unanswered question",

    // 操作结果
    "student_homework_save_success": "Draft saved successfully",
    "student_homework_save_error": "Failed to save draft",
    "student_homework_submit_success": "Homework submitted successfully",
    "student_homework_submit_error": "Failed to submit homework",

    // Tab 标签
    "student_homework_tab_all": "All Homework",
    "student_homework_tab_not_answered": "Not Answered",
    "student_homework_tab_questions": "Questions",
    "student_homework_tab_question_distribution": "Question Distribution",
    "student_homework_tab_answer_result": "Answer Result",

    // 答题模式
    "student_homework_single_mode": "Single Question",
    "student_homework_multiple_mode": "Multiple Questions",
    "student_homework_prev": "Previous",
    "student_homework_next": "Next",
    "student_homework_question_navigation": "Question Navigation",
    "student_homework_no_question": "No questions available",
    "homework_temp_part": "Part",
    
    // Answer display
    "student_homework_correct_answer": "Correct Answer",
    "student_homework_your_answer_label": "Your Answer",
    "student_homework_correct": "Correct",
    "student_homework_incorrect": "Incorrect",
    "student_homework_partial_correct": "Partially Correct",
    "student_homework_question_score": "Score",
    "student_homework_teacher_comment": "Teacher's Comment",
    "student_homework_score_rate": "Score Rate",
    "student_homework_objective_correct_count": "Objective Correct",
    "student_homework_objective_total_count": "Objective Total",
    "student_homework_objective_correct_rate": "Objective Accuracy",
    "student_homework_filter_partial": "Partial",
    
    // Question distribution and answer result
    "student_homework_question_type": "Question Type",
    "student_homework_correct_count": "Correct",
    "student_homework_question_total_count": "Total",
    "student_homework_correct_rate": "Correct Rate",
    "student_homework_total_score": "Total Score",
    "student_homework_actual_score": "Score",
    "student_homework_use_time_label": "Time Used",
    "student_homework_no_answer_detail": "No answer details available",
    
    // Filter and unanswered questions
    "student_homework_filter_questions": "Filter Questions",
    "student_homework_filter_all": "All",
    "student_homework_filter_correct": "Correct",
    "student_homework_filter_incorrect": "Incorrect",
    "student_homework_filter_unanswered": "Unanswered",
    "student_homework_unanswered_questions_title": "Unanswered Questions",
    "student_homework_unanswered_questions": "{{count}} unanswered questions, question numbers: {{indices}}",
    "student_homework_no_filtered_questions": "No questions match the filter",

    // Class list
    "student_class_title": "My Classes",
    "student_class_load_error": "Failed to load class list",
    "student_class_no_classes": "No classes available",
    "student_class_search_placeholder": "Search class name or description",
    "student_class_status_init": "Initialized",
    "student_class_status_running": "Running",
    "student_class_status_end": "Ended",
    "student_class_status_disabled": "Disabled",
    "student_class_start_time": "Start Time",
    "student_class_end_time": "End Time",
    "student_class_enter_class": "Enter Class",
    "student_class_view_detail": "View Details",
    "student_class_view_mode_cards": "Card View",
    "student_class_view_mode_list": "List View",

    // Class detail
    "student_class_detail_title": "Class Details",
    "student_class_detail_info": "Class Information",
    "student_class_detail_homework": "Homework",
    "student_class_detail_teachers": "Teachers",
    "student_class_detail_students": "Students",
    "student_class_detail_description": "Description",
    "student_class_detail_status": "Status",
    "student_class_detail_no_description": "No description",

    // Exam mode
    "student_homework_tab_online_exam": "Online Exams",
    "student_homework_exam_tag": "Exam",
    "student_homework_start_exam": "Start Exam",
    "student_homework_continue_exam": "Continue Exam",
    "student_exam_start_title": "Online Exam",
    "student_exam_start_alert": "Please confirm before starting",
    "student_exam_start_hint": "The timer starts immediately; your exam will be auto-submitted when time runs out",
    "student_exam_start_description": "Complete the exam independently. Keep this page open. Remaining time is shown at the top.",
    "student_exam_start_button": "Start Exam",
    "student_exam_duration_label": "Duration: {{minutes}} minutes",
    "student_exam_auto_submit_success": "Time is up. Your exam has been submitted automatically.",
    "student_exam_time_remaining": "Time Remaining",
    "student_exam_duration_column": "Time Limit",
};
